// extracted by mini-css-extract-plugin
export default {"notFoundErrorBox":"Artist_notFoundErrorBox__KxRdN"};